import dayjs from "dayjs";
import numeral from "numeral";

/**
 * Pul summasini tizim formatida ko'rsatadi.
 * numeral.formats[...] ro'yxatdan o'tmagan bo'lsa zaxira formatga tushadi.
 *
 * @param {number|string|null} value
 * @param {string} systemMoneyFormat selectSystemMoneyFormat qiymati
 * @returns {string}
 */
export const formatBillingMoney = (value, systemMoneyFormat) => {
    if (value === null || value === undefined || value === '') return '';

    const formatter = numeral.formats[systemMoneyFormat];

    if (formatter?.format) return formatter.format(value);

    return numeral(value).format('0,0.00');
};

/**
 * Billing sanasini ko'rsatish uchun formatlaydi.
 * Barcha *_at maydonlari spec'da formatsiz string — yaroqsiz qiymatda bo'sh qaytaradi.
 *
 * @param {string|null} value
 * @param {string} [format]
 * @returns {string}
 */
export const formatBillingDate = (value, format = 'DD.MM.YYYY HH:mm') => {
    if (!value) return '';

    const date = dayjs(value);

    if (!date.isValid()) return '';

    // Go'ning zero-time qiymati ("0001-01-01T00:00:00Z") — bo'sh deb hisoblaymiz.
    if (date.year() <= 1) return '';

    return date.format(format);
};

/**
 * Yozuv soft-delete qilinganmi.
 * deleted_at null, bo'sh string yoki Go zero-time bo'lishi mumkin — uchalasi ham "o'chirilmagan".
 *
 * @param {object} row
 * @returns {boolean}
 */
export const isBillingSoftDeleted = (row) => {
    const value = row?.deleted_at;

    if (!value) return false;

    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) return false;
        if (trimmed.startsWith('0001-01-01')) return false;
    }

    return true;
};

/**
 * Paket muddatini matnga aylantiradi.
 * Diqqat: backend'da maydon nomi "duration_moths" (typo) — aynan shu nom o'qiladi.
 *
 * @param {object} billingPackage contracts.PackageContract
 * @param {string} lang
 * @param {function} t Translate
 * @returns {string}
 */
export const formatPackageDuration = (billingPackage, lang, t) => {
    const months = Number(billingPackage?.duration_moths) || 0;
    const days = Number(billingPackage?.duration_days) || 0;
    const parts = [];

    if (months > 0) parts.push(`${months} ${t(lang, 'admin.organization.package_visibility.duration.months')}`);
    if (days > 0) parts.push(`${days} ${t(lang, 'admin.organization.package_visibility.duration.days')}`);

    return parts.join(' ');
};
